// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18QDV","name":"styles_name__3jFuG","phone":"styles_phone__iAmHD"};